import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints'

const {
  endpoints: {
    users: {
      byListsUrl,
      bySearchUrl,
      byQueryUrl,
      exportCsvUrl,
      updateStateUrl,
      externalUpdateUrl,
      getAvatarUrl,
      filters
    }
  }
} = config

const byLists = (params) => axios.get(byListsUrl, { headers: getHeaders(true), params })

const byQuery = (params) => axios.get(`${byQueryUrl}${params}`, { headers: getHeaders(true) })

const bySearch = (params) => axios.get(`${bySearchUrl}`, { headers: getHeaders(true), params })

const updateState = (data) => axios.post(updateStateUrl, data, { headers: getHeaders(true) })

const externalUpdate = ({ value, key, ticketId }) =>
  axios({
    method: 'put',
    url: externalUpdateUrl.replace(':ticketId', ticketId),
    headers: getHeaders(true),
    data: { value, key },
  })

/**
 *  Download CSV with filters
 */
const exportCsvInfo = (params) => axios.get(exportCsvUrl, { responseType: 'blob', headers: getHeaders(true), params })

const getAvatar = (data) => axios.post(getAvatarUrl, data, { headers: getHeaders(true) })

const getFilters = (params) => axios.get(filters, { headers: getHeaders(true), params })

export default {
  byLists,
  byQuery,
  bySearch,
  exportCsvInfo,
  updateState,
  externalUpdate,
  getAvatar,
  getFilters
}
